import HttpError from './HttpError.js';
export default class WebRequest {
    constructor() {
        this._path = '';
        this._method = 'GET';
        this._contentType = 'application/json';
        this._headers = [];
        this._tags = [];
        // This flags the client that auth headers should not be added to the request.
        this._skipAuth = false;
    }
    get pathValue() {
        return this._path;
    }
    get methodValue() {
        return this._method;
    }
    get contentTypeValue() {
        return this._contentType;
    }
    get bodyValue() {
        return this._body;
    }
    get headersValue() {
        return [...this._headers];
    }
    get cacheTags() {
        return [...this._tags];
    }
    skipAuth(flag) {
        this._skipAuth = flag;
        return this;
    }
    path(v) {
        this._path = v;
        return this;
    }
    method(method) {
        this._method = method;
        return this;
    }
    contentType(type) {
        this._contentType = type;
        return this;
    }
    cached(tags) {
        this._tags = tags;
        return this;
    }
    body(body) {
        this._body = body;
        return this;
    }
    form(formData) {
        this._body = formData;
        this._contentType = 'multipart/form-data';
        return this;
    }
    header(key, value) {
        this._headers.push([key, value]);
        return this;
    }
    headers(headers) {
        this._headers = headers;
        return this;
    }
    buildRequestInit() {
        const initHeaders = this._contentType === 'multipart/form-data'
            ? {}
            : { 'Content-Type': this._contentType };
        const req = {
            method: this._method,
            headers: this._headers.reduce((prev, [key, value]) => {
                prev[key] = value;
                return prev;
            }, initHeaders),
        };
        if (this._tags.length <= 0)
            req.cache = 'no-store';
        if (this._body) {
            req.body =
                this._contentType === 'application/json'
                    ? JSON.stringify(this._body)
                    : this._body;
        }
        return req;
    }
    async doFetch(baseURL, options = {}) {
        const req = options.requestInitCustomizer
            ? options.requestInitCustomizer(this, this.buildRequestInit())
            : this.buildRequestInit();
        const fetchImpl = options.fetchImpl ?? fetch;
        return await fetchImpl(`${baseURL}${this._path}`, req);
    }
    async fetch(baseURL, options = {}) {
        const res = await this.doFetch(baseURL, options);
        if (res.ok)
            return (await res.json());
        else {
            let response;
            try {
                response = await res.json();
            }
            catch (err) {
                console.error(`Error while trying to convert response to json: ${JSON.stringify(res)}`);
                throw err;
            }
            throw new HttpError(res.status, response);
        }
    }
    async fetchEmpty(baseURL, options = {}) {
        const res = await this.doFetch(baseURL, options);
        if (res.ok)
            return;
        else
            throw new HttpError(res.status, (await res.json()));
    }
    static POST(path) {
        return new WebRequest().path(path).method('POST');
    }
    static PUT(path) {
        return new WebRequest().path(path).method('PUT');
    }
    static GET(path) {
        return new WebRequest().path(path).method('GET');
    }
    static DELETE(path) {
        return new WebRequest().path(path).method('DELETE');
    }
}
